import { useQuery, UseQueryResult } from "@tanstack/react-query";
import useHttpClient, {
  API_SERVICES_NAME,
  ApiResponse,
} from "@/hooks/use-http-client";

export interface INotificationParams {
  is_read?: boolean;
  limit?: number;
  page?: number;
  search?: string;
  all?: boolean;
}

export const useGetListNotifications = (
  params: INotificationParams
): UseQueryResult<any, Error> => {
  const { get } = useHttpClient(API_SERVICES_NAME.PUBLIC);
  return useQuery({
    queryKey: ["notifications-list", { ...params }],
    queryFn: (): Promise<ApiResponse<any>> =>
      get<any>(`/notifications`, { params }),
    select: (response) => response.data.data,
    // Layout-level badge poll (params.all unset) runs forever on every page,
    // so 1s polling was a measurable cause of UI jank during sequence operations.
    refetchInterval: params?.all ? 5000 : 10000,
    // chỉ chạy interval khi tab đang focus
    refetchIntervalInBackground: false,
  });
};
